import cookie from "js-cookie";

const cookieKey = "mgcard-cxid";

/**
 * 获取cxid
 * @returns {String}
 */
export const getCxid = () => {
  return cookie.get(cookieKey) || "";
};

/**
 * 设置cxid cookie
 * @param {String} cxid
 */
export const setCxid = (cxid) => {
  cookie.set(cookieKey, cxid, { expires: 1 });
};
